module.exports = __webpack_public_path__ + "img/w1.28997ae1.jpg";